<template>
  <div :style="{ display: played ? 'flex': 'none' }">
    <IconMusic fill="#B0B0B0"/>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import Helper from '@/utils/helper'
import IconMusic from '@/components/Icons/IconMusic.vue'

export default {
  name: 'AdPlaylistAudio',
  components: {
    IconMusic
  },
  props: {
    playListAudioItems: {
      type: Array,
      required: true
    }
  },
  data () {
    return {
      step: 0,
      played: false,
      sound: new Audio(),
      lastAudioVolume: null
    }
  },
  watch: {
    step () {
      this.playSong({ song: this.currentSong })
    },
    mediaMute () {
      if (!Helper.isNull(this.mediaVolumeMuted)) {
        if (this.sound && this.mediaMute) {
          // Если у аудио индивидуальная настройка громкости - сохраняем
          if (this.sound.volume !== this.mediaVolume) {
            // Сохраняем настройку громкости последнего аудио
            this.lastAudioVolume = this.sound.volume
            this.sound.volume = (this.lastAudioVolume * this.mediaVolumeMuted)
            return
          }
          this.sound.volume = this.mediaVolumeMuted
          return
        }

        if (this.sound && !this.mediaMute) {
          // Если у аудио индивидуальная настройка громкости
          if (!Helper.isNull(this.lastAudioVolume)) {
            this.sound.volume = this.lastAudioVolume
            // Применяем и удаляем настройку громкости последнего аудио
            this.lastAudioVolume = null
            return
          }

          this.sound.volume = this.mediaVolume
        }
      }
    }
  },
  computed: {
    ...mapState({
      baseUrl: state => state.playlist.adItems.baseUrl,
      mediaMute: state => state.playlist.mediaMute,
      totalVolume: state => state.playlist.volumeSetting.getVolumeLevelTotal(),
      mediaVolume: state => state.playlist.volumeSetting.getVolumeLevelMedia(),
      mediaVolumeMuted: state => state.playlist.volumeSetting.getVolumeLevelMediaMuted()
    }),
    lastSongId () {
      return localStorage.getItem('lastSongId')
    },
    currentSong () {
      return this.playListAudioItems[this.step]
    }
  },
  methods: {
    nextStep () {
      if (this.step + 1 === this.playListAudioItems.length) {
        this.step = 0
      } else {
        this.step++
      }
    },
    getCurrentAudioVolume (song) {
      const volume = !Helper.isNull(this.mediaVolume) ? this.mediaVolume : this.totalVolume
      return Helper.isDefined(song.getVolume()) ? (volume * song.getVolume()) : volume
    },
    getSongSrc (path) {
      return this.baseUrl + path
    },
    prepareSongsList () {
      this.played = false

      if (Helper.isDefined(this.lastSongId) && this.step === 0) {
        this.step = this.playListAudioItems.findIndex(item => item.getId() === Number(this.lastSongId))
      }

      if (this.step !== -1) {
        this.playSong({ song: this.currentSong })
      } else {
        // Начинаем проигрываение заного
        this.step = 0
        this.playSong({ song: this.currentSong })
      }
    },
    playSong ({ song }) {
      this.sound.src = this.getSongSrc(song.getFile().getPath())
      this.sound.volume = this.getCurrentAudioVolume(song)
      this.sound.play().catch(() => { /* do nothing */ })
      this.played = true
    },
    onAudioEnded () {
      localStorage.setItem('lastSongId', this.currentSong.getId())
      this.played = false
      this.destroyAudio()
      this.nextStep()
    },
    onAudioError () {
      this.played = false
      this.destroyAudio()
      this.nextStep()
    },
    destroyAudio () {
      if (this.sound) {
        this.sound.pause()
        this.sound.src = ''
        this.sound.load()
      }
    }
  },
  mounted () {
    this.prepareSongsList()
    this.sound.addEventListener('ended', this.onAudioEnded)
    this.sound.addEventListener('error', this.onAudioError)
  },
  beforeDestroy () {
    this.sound.removeEventListener('ended', this.onAudioEnded)
    this.sound.removeEventListener('error', this.onAudioError)
    this.destroyAudio()
    this.sound = null
  }
}

</script>
